import { StyledMDSListBox } from "./dropdown-list.style";
import { MDSDropdownListProps } from "./dropdown-list.types";

export const MDSDropdownList = (props: MDSDropdownListProps) => {
  return <StyledMDSListBox {...props} />;
};
